import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ThemeState {
	themeName: string;
	themeType: string;
	themeSize: string;
}

const initialState: ThemeState = {
	themeName: "main",
	themeType: localStorage.getItem("themeType") === "dark" ? "dark" : "light",
	themeSize: localStorage.getItem("themeSize") || "14",
};

export const themeSlice = createSlice({
	name: "theme",
	initialState,
	reducers: {
		updateThemeName: (state, action: PayloadAction<string>) => {
			state.themeName = action.payload;
		},
		setThemeTypeDark: (state) => {
			localStorage.setItem("themeType", "dark");
			state.themeType = "dark";
		},
		setThemeTypeLight: (state) => {
			localStorage.setItem("themeType", "light");
			state.themeType = "light";
		},
		updateThemeSize: (state, action: PayloadAction<string>) => {
			localStorage.setItem("themeSize", action.payload);
			state.themeSize = action.payload;
		},
	},
});

export const { updateThemeName, updateThemeSize, setThemeTypeDark, setThemeTypeLight } = themeSlice.actions;

export default themeSlice.reducer;
